import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  selectLeaguesSeasons,
  selectCurrentSeason,
  selectCurrentSeasonID,
  buildSeasonsDropdownItems,
} from '../../reducers/leagues_filter_values'
import {
  setConfigsSeason,
  selectConfigsSeason,
  SELECT_SEASON_PLACEHOLDER_VALUE,
} from '../../reducers/leagues_configs'

import { GlgSelect } from 'SharedComponents'

const LeaguesConfigDropdowns = () => {
  const dispatch = useDispatch()

  const seasons = useSelector(selectLeaguesSeasons)
  const currentSeason = useSelector(selectCurrentSeason)
  const currentSeasonID = useSelector(selectCurrentSeasonID)
  const configsSeason = useSelector(selectConfigsSeason)

  const placeholderFirstItem = {
    value: SELECT_SEASON_PLACEHOLDER_VALUE,
    label: window.I18n.t('clone_leagues_sessions.dropdowns.select_a_season'),
  }
  const dropdownSeasons = buildSeasonsDropdownItems(seasons, currentSeasonID, currentSeason, placeholderFirstItem)

  const handleSeasonChange = (seasonID) => {
    if (seasonID === SELECT_SEASON_PLACEHOLDER_VALUE) {
      dispatch(setConfigsSeason({}))
      return
    }
    const item = dropdownSeasons.find(i => i.value === seasonID)
    dispatch(setConfigsSeason({ value: seasonID, label: item?.label || '' }))
  }

  return (
    <div className={'cls-lcd-sc-container'}>
      <div className={'dropdowns-grid'}>
        {/* Season */}
        <div className={'dropdown-wrapper'}>
          <span className={'cls-subtitle-bold'}>
            {window.I18n.t('clone_leagues_sessions.general.season')}
          </span>
          <span>
            <GlgSelect
              onChange={handleSeasonChange}
              value={configsSeason?.value}
              selectorClassName={'dropdown-select'}
              items={dropdownSeasons}
            />
          </span>
        </div>
      </div>
    </div>
  )
}

export default LeaguesConfigDropdowns
